export default "__VITE_ASSET__VslmCuzS__"